import * as C from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as c } from "../../utilities/transformations.js";
import { distort as _ } from "../../helpers/distort.js";
import { grain as w } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as E } from "../../utilities/uv.js";
const N = {
  name: "Vapor7",
  collection: "vapor",
  tags: ["wave", "gradient", "colorful"],
  props: {
    colorA: {
      type: String,
      default: "rgba(177,110,216,0.58)",
      transform: c,
      description: "The first color of the vapor wave."
    },
    colorB: {
      type: String,
      default: "#C0D684",
      transform: c,
      description: "The second color of the vapor wave."
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the waves"
    }
  },
  fragmentNode: (o) => {
    const {
      vec4: a,
      uv: m,
      time: l,
      sin: i,
      mix: r,
      abs: p,
      smoothstep: d,
      blendOverlay: f,
      color: e,
      float: n
    } = C, u = 0.1, F = 23, v = 1, t = _(m(), 0.1, 1, F), g = i(
      t.y.mul(1.5).mul(Math.PI).sub(l.mul(o.speed.uniform).mul(0.5))
    ).mul(0.2).add(0.5).sub(u), b = r(
      o.colorA.uniform,
      o.colorB.uniform,
      t.x
    ), h = p(t.y.sub(g)).mul(2), s = d(
      n(0.5),
      0,
      h.mul(n(0.5))
    ), { correctedUV: T } = E(), y = w(1)(T), A = b.mul(s).sub(y);
    return f(a(
      r(
        e("#FFFFFF"),
        A,
        s.mul(v)
      ),
      1
    ), e("#FFFFFF"));
  }
};
export {
  N as componentDefinition,
  N as default
};
